import dayjs from "dayjs";


const TIMESTAMP_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export function datetimeLocalToString(datetimeLocal) {
    if(datetimeLocal.length === 0) {
        return null;
    }
    return (new dayjs(datetimeLocal)).format(TIMESTAMP_FORMAT);
}

export function stringToDatetimeLocal(string) {
    return (new dayjs(string).format('YYYY-MM-DDTHH:mm'))
}


export function nowUTCTimeStamp() {
    return (new dayjs()).utc().format(TIMESTAMP_FORMAT);
}


export function nowTimeStamp() {
    return (new dayjs()).format(TIMESTAMP_FORMAT);
}


export function stringToFriendlyDatetime(string) {
    return (new dayjs(string).format('HH:mm D/M/YYYY'));

}
